import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";

const Privacy = () => {
  const { t, lang } = useI18n();
  const updated = "2026-05-29";
  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-12">
      <div className="font-mono text-xs tracking-widest text-[#FF3B30] mb-3">// PRIVACY</div>
      <h1 className="font-heading text-4xl md:text-5xl mb-2">
        {lang === "ro" ? "Politică de Confidențialitate" : "Privacy Policy"}
      </h1>
      <div className="font-mono text-xs text-white/40 mb-8">
        {lang === "ro" ? "Ultima actualizare" : "Last updated"}: {updated}
      </div>
      <div className="space-y-4 text-white/80 leading-relaxed text-sm">
        {lang === "ro" ? (
          <>
            <div className="mb-4 p-4" style={{ background: "#0F1F0F", border: "1px solid #2D5A2D" }}>
              <p className="text-sm text-white leading-relaxed m-0">
                <b style={{ color: "#7BE07B" }}>Principiu de bază — minimizarea datelor:</b>{" "}
                Sports Nutrition Engine este conceput astfel încât informațiile despre profilul
                sportiv să rămână, în mod implicit, pe dispozitivul utilizatorului. <b>Nu stocăm
                permanent profilurile sportive, planurile generate sau istoricul alimentar al
                utilizatorilor.</b>
              </p>
            </div>

            <h2 className="font-heading text-xl text-white pt-2">1. Operator de date</h2>
            <p>TRIBOIAI LLC ("noi"), prin sportsnutritionengine.online, este operatorul datelor cu caracter personal pe care le procesăm.</p>
            <h2 className="font-heading text-xl text-white pt-2">2. Ce date colectăm</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li><b>Email-ul tău</b> — pentru livrarea codurilor de acces și comunicări legate de serviciu. Newsletter-ul este opțional și poate fi dezactivat oricând.</li>
              <li><b>Profil sportiv</b> (sex, vârstă, greutate, înălțime, sport, post, obiectiv) — stocat local în browser-ul tău. Datele sunt transmise temporar serverului doar atunci când soliciți generarea unui plan și nu sunt păstrate după finalizarea procesării.</li>
              <li><b>Date check-in</b> (energie, somn, transpirație etc.) — procesate doar la cerere, nu se stochează permanent.</li>
              <li><b>Date de plată</b> — gestionate exclusiv de furnizorul de plăți (când este activat); nu vedem și nu stocăm datele cardului tău.</li>
            </ul>
            <h2 className="font-heading text-xl text-white pt-2">3. De ce le folosim</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>Generarea planului tău personalizat (procesare temporară, fără stocare permanentă)</li>
              <li>Livrarea codului de acces după plată</li>
              <li>Suport tehnic și remediere bug-uri</li>
              <li>Comunicări de produs (cu opt-out)</li>
            </ul>
            <h2 className="font-heading text-xl text-white pt-2">4. Cu cine partajăm</h2>
            <p>Nu vindem și nu distribuim datele tale către terți. Datele pot fi procesate de furnizorii tehnici necesari funcționării serviciului (ex. infrastructură cloud și baze de date). Nu folosim cookies de tracking sau servicii de publicitate.</p>
            <h2 className="font-heading text-xl text-white pt-2">5. Cookies</h2>
            <p>Folosim doar cookies / localStorage strict necesare funcționării (cod acces, profil, limbă preferată). Nu folosim cookies de tracking sau publicitate.</p>
            <h2 className="font-heading text-xl text-white pt-2">6. Drepturile tale (GDPR)</h2>
            <p>Ai dreptul să accesezi, corectezi, ștergi sau să primești o copie a datelor tale, să te opui prelucrării și să depui plângere la autoritatea competentă. Prin natura arhitecturii, <b>nu păstrăm în mod permanent greutatea, înălțimea, sportul, postul, obiectivele sau planurile generate</b> — datele tale sportive rămân pe dispozitivul tău. Scrie la <a href="mailto:iuliantriboi@gmail.com" className="text-[#FF3B30]">iuliantriboi@gmail.com</a>.</p>
            <h2 className="font-heading text-xl text-white pt-2">7. Reținere</h2>
            <p>Datele necesare evidenței comerciale și fiscale (ex. corespondența legată de coduri de acces) pot fi păstrate conform obligațiilor legale aplicabile. Profilurile sportive și datele utilizate pentru generarea planurilor nu sunt păstrate permanent. Email-urile de newsletter pot fi șterse la cerere oricând.</p>
          </>
        ) : (
          <>
            <div className="mb-4 p-4" style={{ background: "#0F1F0F", border: "1px solid #2D5A2D" }}>
              <p className="text-sm text-white leading-relaxed m-0">
                <b style={{ color: "#7BE07B" }}>Core principle — data minimization:</b>{" "}
                Sports Nutrition Engine is designed so that athletic profile information
                stays, by default, on the user's device. <b>We do not permanently store user
                athletic profiles, generated plans or food logs.</b>
              </p>
            </div>

            <h2 className="font-heading text-xl text-white pt-2">1. Data controller</h2>
            <p>TRIBOIAI LLC ("we"), operating sportsnutritionengine.online, is the controller of the personal data we process.</p>
            <h2 className="font-heading text-xl text-white pt-2">2. What we collect</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li><b>Your email</b> — for access-code delivery and service-related communications. The newsletter is optional and can be unsubscribed at any time.</li>
              <li><b>Athletic profile</b> (sex, age, weight, height, sport, position, goal) — stored locally in your browser. Data is transmitted to the server only when you request plan generation and is not retained after processing.</li>
              <li><b>Check-in data</b> (energy, sleep, sweat, etc.) — processed on-demand only, not permanently stored.</li>
              <li><b>Payment data</b> — handled exclusively by the payment provider (when enabled); we never see or store your card details.</li>
            </ul>
            <h2 className="font-heading text-xl text-white pt-2">3. Why we use it</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>To generate your personalized plan (temporary processing, no permanent storage)</li>
              <li>To deliver your access code after payment</li>
              <li>Technical support and bug fixes</li>
              <li>Product communications (with opt-out)</li>
            </ul>
            <h2 className="font-heading text-xl text-white pt-2">4. Sharing</h2>
            <p>We do not sell or distribute your data to third parties. Data may be processed by technical providers strictly necessary to operate the service (e.g. cloud infrastructure and databases). No tracking cookies, no ad services.</p>
            <h2 className="font-heading text-xl text-white pt-2">5. Cookies</h2>
            <p>We use only strictly necessary cookies / localStorage (access code, profile, preferred language). No tracking or ad cookies.</p>
            <h2 className="font-heading text-xl text-white pt-2">6. Your rights (GDPR)</h2>
            <p>You have the right to access, correct, delete, or get a copy of your data, to object to processing, and to file a complaint with your local DPA. By architecture, <b>we do not permanently retain weight, height, sport, position, goals or generated plans</b> — your athletic data stays on your device. Contact <a href="mailto:iuliantriboi@gmail.com" className="text-[#FF3B30]">iuliantriboi@gmail.com</a>.</p>
            <h2 className="font-heading text-xl text-white pt-2">7. Retention</h2>
            <p>Data required for commercial and tax recordkeeping (e.g. correspondence related to access codes) may be retained as required by applicable law. Athletic profiles and the data used to generate plans are not permanently stored. Newsletter emails can be removed on request at any time.</p>
          </>
        )}

        <div className="mt-8 p-4" style={{ background: "#141414", border: "1px solid #27272A" }}>
          <div className="font-bold text-white mb-1">TRIBOIAI LLC</div>
          <div className="text-sm text-white/70">File No. 2026-001869654</div>
          <div className="text-sm text-white/70">1021 E Lincolnway Suite 9733, Cheyenne, WY 82001, USA</div>
          <div className="text-sm text-white/70">contact: iuliantriboi@gmail.com</div>
          <div className="text-xs text-white/40 mt-2">© 2026. All Rights Reserved.</div>
        </div>

        <Link to="/" data-testid="privacy-back-home">
          <button className="btn-secondary mt-6">← {t.common.back_home}</button>
        </Link>
      </div>
    </div>
  );
};

export default Privacy;
